/**
 * Kirpilan metinler icin hover tooltip'i: `v-overflow-tooltip`
 *
 * Uzun degerler alanin genisligine sigmayip "..." ile kesiliyor; kullanici tam metni
 * gorebilmek icin dropdown'i acmak zorunda kaliyordu. Direktif, metin gercekten kirpildiysa
 * uzerine gelindiginde tamamini gosterir - sigan metinlerde tooltip hic acilmaz.
 *
 * Iki kullanimi var: dogrudan elemana (`v-overflow-tooltip`, ornegin bir metin girdisi) ya da
 * bir secici verilerek kapsayiciya delegasyonla:
 * `v-overflow-tooltip="'.select2-selection__rendered'"`. select2'nin secim kutusu jQuery
 * tarafindan surekli yeniden uretiliyor (deger degisimi, liste yenilenmesi, breadcrumb'in elle
 * yazilmasi); delegasyon sayesinde bagin her uretimde yenilenmesi gerekmiyor.
 */

const NAMESPACE = '.overflow-tooltip';
const MOUSEENTER = `mouseenter${NAMESPACE}`;

const TOOLTIP_OPTIONS = {
  // Varsayilan 'hover focus' olsaydi girdiye yazmak icin tiklandiginda da tooltip acilirdi.
  trigger: 'hover',
  // Hem select2 kutusu hem modal govdesi tasan icerigi kirpiyor; tooltip body'ye asilir.
  container: 'body',
  // Popper sinirlari yine de referans elemana gore hesapliyor: varsayilan 'scrollParent'
  // tooltip'i kaydirilabilir modal govdesinin icine hapsederdi.
  boundary: 'window',
  delay: { show: 300, hide: 0 },
  // Metronic'in initTooltip'iyle ayni sablon (scripts.bundle.js), tek farki genislik ve
  // hizalamayi tasiyan m-tooltip--overflow sinifi (bkz. otomatica.scss).
  template: '<div class="m-tooltip m-tooltip--overflow tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
};

const fullText = (element) => {
  if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
    return element.value || '';
  }
  // select2'nin temizleme dugmesi (x) secim kutusunun cocugu ama metnin parcasi degil.
  const $text = $(element).clone();
  $text.find('.select2-selection__clear').remove();
  return $text.text();
};

/**
 * Tooltip icerigi hover aninda tazelenir; yoksa deger degistiginde eski metin gosterilirdi.
 * Bootstrap basligi once `data-original-title`dan okudugu icin metin oraya yazilir; bos
 * birakildiginda tooltip acilmaz - kirpilmayan metinlerde istedigimiz de budur. `title` her
 * seferinde silinir; kalirsa select2'nin her uretimde bastigi tarayici tooltip'i bizimkiyle
 * ayni anda gorunur.
 */
function refreshTitle() {
  const truncated = this.scrollWidth - this.clientWidth > 1;
  this.removeAttribute('title');
  this.setAttribute('data-original-title', truncated ? fullText(this).trim() : '');
}

export const overflowTooltipDirective = {
  inserted(element, binding) {
    const selector = binding.value;
    // mouseenter dinleyicimiz bootstrap'inkinden ONCE baglanmali: bootstrap tooltip ornegini
    // ilk hover'da kuruyor ve kurarken basligi elemandan okuyor.
    $(element)
      .on(MOUSEENTER, selector, refreshTitle)
      .tooltip(selector ? { ...TOOLTIP_OPTIONS, selector } : TOOLTIP_OPTIONS);
  },
  unbind(element, binding) {
    // Delegasyonla acilan tooltip ornekleri alt elemanlarda durur; yalnizca kapsayiciyi
    // kapatmak onlari kapatmaz ve body'de artik tooltip birakabilirler.
    $(element).find(binding.value).addBack().tooltip('dispose');
    $(element).off(NAMESPACE);
  },
};
